/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Po_Issue_Unknown_ChangeInputs */

const en_po_issue_unknown_change = /** @type {(inputs: Po_Issue_Unknown_ChangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`is not a proposal of this purchase order`)
};

/**
* | output |
* | --- |
* | "is not a proposal of this purchase order" |
*
* @param {Po_Issue_Unknown_ChangeInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const po_issue_unknown_change = /** @type {((inputs?: Po_Issue_Unknown_ChangeInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Po_Issue_Unknown_ChangeInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_po_issue_unknown_change(inputs)
});